export function translationConfig(
  $translateProvider,
  $translatePartialLoaderProvider,
  translatePluggableLoaderProvider
) {
  'ngInject';
  // Sanitize of variable content
  $translateProvider.useLoaderCache(true);
  $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

  // Instead of using the message format interpolation as the default interpolation,
  // we add the message format interpolation service as an 'optional' interpolation type.
  // Read more about this decision at `The drawback` on https://angular-translate.github.io/docs/#/guide/14_pluralization
  $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

  // Use partial loader for translations loading
  $translateProvider.useLoader('translatePluggableLoader');
  translatePluggableLoaderProvider.useLoader('$translatePartialLoader', {
    urlTemplate: '{part}/lang/{lang}.json'
  });

  // Add initial translate partial(s)
  $translatePartialLoaderProvider.addPart('app');

  // Set and use default language
  $translateProvider.preferredLanguage('de');
  $translateProvider.use('de');
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-translation/src/translation.config.js